/** Implicit Turnstile widget'ının gizli alanından token okur. */
export function captchaToken(): string {
  return document.querySelector<HTMLInputElement>('[name="cf-turnstile-response"]')?.value ?? '';
}

/**
 * Token tek kullanımlıktır; sunucuya gittikten sonra widget yenilenmezse aynı değer
 * tekrar gider ve Cloudflare 403 döner. Yalnızca istek gönderildikten sonra çağırın.
 */
export function resetCaptcha(): void {
  const api = (window as unknown as { turnstile?: { reset: () => void } }).turnstile;
  try { api?.reset(); } catch { /* betik henüz yüklenmemiş olabilir */ }
}
